





import {
  defineComponent,
  ref,
  watch,
} from '@vue/composition-api';
import { useFormat, useRouter } from '@ideavivat/vivat-2';

import FanCam from '@/components/FanCam/Index.vue';

const FanCamIndex = defineComponent({
  components: {
    FanCam,
  },
  setup(props: any, { emit }) {
    const { route, router } = useRouter();
    const forcedRerender = ref(true);
    const deleteItemsModal = ref(null);

    watch(() => route.value.params.liveId, () => {
      forcedRerender.value = false;
      forcedRerender.value = true;
    });

    return {
    };
  },
});

export default FanCamIndex;
